import { render, staticRenderFns } from "./tabMAWB.vue?vue&type=template&id=1543fb4a&scoped=true&"
import script from "./tabMAWB.vue?vue&type=script&lang=js&"
export * from "./tabMAWB.vue?vue&type=script&lang=js&"
import style0 from "./tabMAWB.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./tabMAWB.vue?vue&type=style&index=1&id=1543fb4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1543fb4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1543fb4a')) {
      api.createRecord('1543fb4a', component.options)
    } else {
      api.reload('1543fb4a', component.options)
    }
    module.hot.accept("./tabMAWB.vue?vue&type=template&id=1543fb4a&scoped=true&", function () {
      api.rerender('1543fb4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirImport/components/booking/tabs/tabMAWB.vue"
export default component.exports